import { MessageHistory } from '@app/components/LeadCard/ui/MessageHistory';

import type { FC } from 'react';

import './MainBody.scss';

export const MainBody: FC = () => (
  <section className="MainBody">
    <div className="MainBody__messages">
      <MessageHistory />
    </div>
  </section>
);
